import React from "react";
import Titles from "../layouts/Titles";
import ProjectsCard from "./ProjectsCard";
import { FaGlobe } from "react-icons/fa";
import { pc1, zuzu,web, ebh,zuzuq , sales} from "../../assets/index";
const MyProjects = () => {
  return (
    <section
      id="projects"
      className="w-full py-20 border-b-[1px] border-b-black "
    >
      <div className="flex justify-center items-center text-center">
        <Titles
          title="ACHIEVEMENTS"
          des="My Projects"
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 xl:gap-14">
        <ProjectsCard
          title="System Vulnerability Exploits"
          des="I frequently like to exploit security holes in the 
          software to find flaws and fix them."
          src={pc1}
          icon={<a href="https://maxongomeka.netlify.app"><FaGlobe/></a> }
        />
        <ProjectsCard
          title="ZuzuDiary Mobile App"
          des="A mobile application that protects user notes from alteration by
           outside parties. You can get it from the Google Play store."
          src={zuzu}
          icon={<a href="https://play.google.com/store/apps/details?id=com.zuzuDiary.another_app"><FaGlobe/></a> }
        />
        <ProjectsCard
          title="Macheda Graphics Website"
          des="An appealing website that houses all of
           Macheda Graphics' creations. We are here to design for you."
          src={web}
          icon={<a href="https://machedagraphics.netlify.app"><FaGlobe/></a> }
        />
        <ProjectsCard
          title="Sales Management System"
          des="This desktop application is for managing sales. 
          All products are kept in the system, and everything 
          is neatly arranged and easy to use."
          src={sales}
          icon={<a href="https://maxongomeka.netlify.app"><FaGlobe/></a> }
        />
        <ProjectsCard
          title="EBH Autoparts Website"
          des="All of the items sold by EBH Auto Parts 
            are available on this website."
          src={ebh}
          icon={<a href="https://ebhautoparts.netlify.app"><FaGlobe/></a> }
        />
        <ProjectsCard
          title="Programmed Questionaire "
          des="The cost is determined on the questionnaire and the amount
           of randomization used, which I typically program
           for various people. Its cost for data analysis is set. "
          src={zuzuq}
          icon={<a href="https://maxongomeka.netlify.app"><FaGlobe/></a> }
        />
      </div>
    </section>
  );
};

export default MyProjects;
